var swiper = new Swiper('.mySwiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  centeredSlides: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    640: { slidesPerView: 2 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
    1550: { slidesPerView: 5 },
  },
  on: {
    init: function () {
      setActiveSlide(this);
    },
    slideChange: function () {
      setActiveSlide(this);
    },
    setTranslate: function () {
      setActiveSlide(this);
    },
  },
});

function setActiveSlide(swiper) {
  const slides = swiper.slides;
  const slidesPerView = swiper.params.slidesPerView;

  // Always reset classes first
  slides.forEach((slide) => {
    slide.classList.remove('active', 'not-active');
  });

  // Only apply active/not-active logic when there are 3 or more visible slides
  if (slidesPerView >= 3) {
    slides.forEach((slide) => {
      slide.classList.add('not-active');
    });

    const activeIndex = swiper.activeIndex;
    const activeSlide =
      slides[activeIndex + Math.floor(slidesPerView / 2)];

    if (activeSlide) {
      activeSlide.classList.add('active');
      activeSlide.classList.remove('not-active');
    }
  }
}


           // Wait for DOM
        document.addEventListener('DOMContentLoaded', function () {
            const wrapper = document.querySelector('.swiper-wrapper-new');
            const slidesCount = wrapper ? wrapper.children.length : 0;

            // If there are fewer slides than desired slidesPerView, disable loop
            const desiredDesktopSlides = 3;
            const shouldLoop = slidesCount > desiredDesktopSlides;

            const swiper = new Swiper('.mySwiper-2', {
                slidesPerView: 3,
                spaceBetween: 28,
                loop: shouldLoop,
                observer: true,
                observeParents: true,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                        autoplay: {
            delay: 3000, // 3 seconds
            disableOnInteraction: false, // keeps autoplay running even after user interaction
        },
        speed: 800,
                breakpoints: {
                    0: { slidesPerView: 1, spaceBetween: 16 },
                    640: { slidesPerView: 2, spaceBetween: 20 },
                    1024: { slidesPerView: 3, spaceBetween: 28 }
                }
            });

            // expose for debugging (optional)
            window.__myTestSw = swiper;
        });


        // Function to equalize card heights
function equalizeCardHeights() {
    const cards = document.querySelectorAll('.new-slide-2');
    
    // Reset heights first
    cards.forEach(card => {
        card.style.minHeight = '';
    });
    
    // Find the tallest card
    let maxHeight = 0;
    cards.forEach(card => {
        const height = card.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    
    // Apply the max height to all cards
    cards.forEach(card => {
        card.style.minHeight = maxHeight + 'px';
    });
}

// Run on page load
window.addEventListener('load', equalizeCardHeights);

// Run on window resize (debounced)
let resizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeCardHeights, 250);
});

// If using Swiper, run after initialization
// Uncomment and adjust if you have a Swiper instance
/*
document.addEventListener('DOMContentLoaded', () => {
    // Wait for Swiper to initialize
    setTimeout(equalizeCardHeights, 100);
});
*/

var swiper = new Swiper(".myswiper-new", {
  navigation: {
    nextEl: ".nav-next",
    prevEl: ".nav-prev",
  },
  loop: true,
  effect: "slide",
  speed: 450,
  allowTouchMove: false,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
});

var leftSwiper = new Swiper(".leftSwiper", {
  loop: true,
  effect: "slide",
  speed: 450,
  allowTouchMove: false,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
});

// Sync sliders
swiper.on('slideChange', function () {
  leftSwiper.slideToLoop(swiper.realIndex, 450, false);
});

// Pause autoplay on hover
function setupHoverPause(selector, mainSwiper, syncedSwiper) {
  const element = document.querySelector(selector);

  if (!element) return;

  element.addEventListener("mouseenter", function () {
    mainSwiper.autoplay.stop();
    syncedSwiper.autoplay.stop();
  });

  element.addEventListener("mouseleave", function () {
    mainSwiper.autoplay.start();
    syncedSwiper.autoplay.start();
  });
}

// Apply to both slider containers
setupHoverPause(".myswiper-new", swiper, leftSwiper);
setupHoverPause(".leftSwiper", leftSwiper, swiper);




